import React, { useEffect, useRef } from "react";
var usePrefersColorScheme = function(param) {
    var callback = param.callback, colorScheme = param.colorScheme;
    var hasExecuted = useRef(colorScheme);
    useEffect(function() {
        if (typeof hasExecuted.current === 'undefined') {
            if (callback) {
                var ref;
                callback(((ref = window.matchMedia('(prefers-color-scheme: dark)')) === null || ref === void 0 ? void 0 : ref.matches) ? 'dark' : 'light');
            }
            hasExecuted.current = true;
        }
    }, [
        callback
    ]);
};
export default usePrefersColorScheme;
